import React from 'react';
import { constants, useTranslation } from 'cng-web-lib'

import Namespace from "../../../constants/locale/Namespace";
import TmpMassUploadKeys from 'src/constants/locale/key/TmpMassUpload'

const NAMESPACE = Namespace.TMP_MASS_UPLOAD;

const {
    locale: {
        key: {
            UiComponentKeys,
        },
    },
} = constants

const TranslationText = () => {

    const { translate } = useTranslation([NAMESPACE])

    const moduleTitle = translate(NAMESPACE, TmpMassUploadKeys.TMP_MASS_UPLOAD_TITLE);
    const downloadTemplate = translate(NAMESPACE, TmpMassUploadKeys.TMP_MASS_DOWNLOAD_TEMPLATE);
    const uploadButton = translate(NAMESPACE, TmpMassUploadKeys.TMP_MASS_UPLOAD_BUTTON);


    let tmpMassUpload = translate(NAMESPACE, TmpMassUploadKeys.TMP_MASS_UPLOAD_TITLE)


    return {
        moduleTitle,
        downloadTemplate,
        uploadButton,
        tmpMassUpload
    }
}

export default TranslationText;


